module.exports = require("prismjs/components/prism-csharp.js");